import { type TileCoordinates } from "@/types/tile";
import type { FrameName } from "../entities/config";
import CoalDepositTerrainTileEntity from "../entities/terrains/CoalDepositTerrainTileEntity";
import DeepSeaBigFishTerrainTileEntity from "../entities/terrains/DeepSeaBigFishTerrainTileEntity";
import DeepSeaCoralReefTerrainTileEntity from "../entities/terrains/DeepSeaCoralReefTerrainTileEntity";
import DeepSeaMediumFishTerrainTileEntity from "../entities/terrains/DeepSeaMediumFishTerrainTileEntity";
import DeepSeaTerrainTileEntity from "../entities/terrains/DeepSeaTerrainTileEntity";
import DenseForestTerrainTileEntity from "../entities/terrains/DenseForestTerrainTileEntity";
import ForestTerrainTileEntity from "../entities/terrains/ForestTerrainTileEntity";
import GemsVeinTerrainTileEntity from "../entities/terrains/GemsVeinTerrainTileEntity";
import GoldVeinTerrainTileEntity from "../entities/terrains/GoldVeinTerrainTileEntity";
import Grassland1TerrainTileEntity from "../entities/terrains/Grassland1TerrainTileEntity";
import Grassland2TerrainTileEntity from "../entities/terrains/Grassland2TerrainTileEntity";
import Grassland3TerrainTileEntity from "../entities/terrains/Grassland3TerrainTileEntity";
import Grassland4TerrainTileEntity from "../entities/terrains/Grassland4TerrainTileEntity";
import GrasslandTerrainTileEntity from "../entities/terrains/GrasslandTerrainTileEntity";
import HillsTerrainTileEntity from "../entities/terrains/HillsTerrainTileEntity";
import IronMountainsTerrainTileEntity from "../entities/terrains/IronMountainsTerrainTileEntity";
import MountainsTerrainTileEntity from "../entities/terrains/MountainsTerrainTileEntity";
import OldForestTerrainTileEntity from "../entities/terrains/OldForestTerrainTileEntity";
import River10TerrainTileEntity from "../entities/terrains/River10TerrainTileEntity";
import River11TerrainTileEntity from "../entities/terrains/River11TerrainTileEntity";
import River12TerrainTileEntity from "../entities/terrains/River12TerrainTileEntity";
import River13TerrainTileEntity from "../entities/terrains/River13TerrainTileEntity";
import River14TerrainTileEntity from "../entities/terrains/River14TerrainTileEntity";
import River15TerrainTileEntity from "../entities/terrains/River15TerrainTileEntity";
import River3TerrainTileEntity from "../entities/terrains/River3TerrainTileEntity";
import River5TerrainTileEntity from "../entities/terrains/River5TerrainTileEntity";
import River6TerrainTileEntity from "../entities/terrains/River6TerrainTileEntity";
import River7TerrainTileEntity from "../entities/terrains/River7TerrainTileEntity";
import River9TerrainTileEntity from "../entities/terrains/River9TerrainTileEntity";
import RiverDelta1TerrainTileEntity from "../entities/terrains/RiverDelta1TerrainTileEntity";
import RiverDelta2TerrainTileEntity from "../entities/terrains/RiverDelta2TerrainTileEntity";
import RiverDelta4TerrainTileEntity from "../entities/terrains/RiverDelta4TerrainTileEntity";
import RiverDelta8TerrainTileEntity from "../entities/terrains/RiverDelta8TerrainTileEntity";
import RiverSpring1TerrainTileEntity from "../entities/terrains/RiverSpring1TerrainTileEntity";
import RiverSpring2TerrainTileEntity from "../entities/terrains/RiverSpring2TerrainTileEntity";
import RiverSpring4TerrainTileEntity from "../entities/terrains/RiverSpring4TerrainTileEntity";
import RiverSpring8TerrainTileEntity from "../entities/terrains/RiverSpring8TerrainTileEntity";
import RuinedForestTerrainTileEntity from "../entities/terrains/RuinedForestTerrainTileEntity";
import SaltDepositTerrainTileEntity from "../entities/terrains/SaltDepositTerrainTileEntity";
import SettlementEmpty10TerrainTileEntity from "../entities/terrains/SettlementEmpty10TerrainTileEntity";
import SettlementEmpty11TerrainTileEntity from "../entities/terrains/SettlementEmpty11TerrainTileEntity";
import SettlementEmpty12TerrainTileEntity from "../entities/terrains/SettlementEmpty12TerrainTileEntity";
import SettlementEmpty13TerrainTileEntity from "../entities/terrains/SettlementEmpty13TerrainTileEntity";
import SettlementEmpty14TerrainTileEntity from "../entities/terrains/SettlementEmpty14TerrainTileEntity";
import SettlementEmpty15TerrainTileEntity from "../entities/terrains/SettlementEmpty15TerrainTileEntity";
import SettlementEmpty16TerrainTileEntity from "../entities/terrains/SettlementEmpty16TerrainTileEntity";
import SettlementEmpty17TerrainTileEntity from "../entities/terrains/SettlementEmpty17TerrainTileEntity";
import SettlementEmpty18TerrainTileEntity from "../entities/terrains/SettlementEmpty18TerrainTileEntity";
import SettlementEmpty19TerrainTileEntity from "../entities/terrains/SettlementEmpty19TerrainTileEntity";
import SettlementEmpty1TerrainTileEntity from "../entities/terrains/SettlementEmpty1TerrainTileEntity";
import SettlementEmpty2TerrainTileEntity from "../entities/terrains/SettlementEmpty2TerrainTileEntity";
import SettlementEmpty3TerrainTileEntity from "../entities/terrains/SettlementEmpty3TerrainTileEntity";
import SettlementEmpty4TerrainTileEntity from "../entities/terrains/SettlementEmpty4TerrainTileEntity";
import SettlementEmpty5TerrainTileEntity from "../entities/terrains/SettlementEmpty5TerrainTileEntity";
import SettlementEmpty6TerrainTileEntity from "../entities/terrains/SettlementEmpty6TerrainTileEntity";
import SettlementEmpty7TerrainTileEntity from "../entities/terrains/SettlementEmpty7TerrainTileEntity";
import SettlementEmpty8TerrainTileEntity from "../entities/terrains/SettlementEmpty8TerrainTileEntity";
import SettlementEmpty9TerrainTileEntity from "../entities/terrains/SettlementEmpty9TerrainTileEntity";
import SettlementEmptyTerrainTileEntity from "../entities/terrains/SettlementEmptyTerrainTileEntity";
import ShallowSeaCoralReefTerrainTileEntity from "../entities/terrains/ShallowSeaCoralReefTerrainTileEntity";
import ShallowSeaMediumFishTerrainTileEntity from "../entities/terrains/ShallowSeaMediumFishTerrainTileEntity";
import ShallowSeaRocksTerrainTileEntity from "../entities/terrains/ShallowSeaRocksTerrainTileEntity";
import ShallowSeaSmallFishTerrainTileEntity from "../entities/terrains/ShallowSeaSmallFishTerrainTileEntity";
import ShallowSeaTerrainTileEntity from "../entities/terrains/ShallowSeaTerrainTileEntity";
import SwampTerrainTileEntity from "../entities/terrains/SwampTerrainTileEntity";
import type TileEntity from "../entities/TileEntity";
import type TileRepository from "../TileRepository";

const map = new Map<FrameName, typeof TileEntity>();
map.set(
	DeepSeaBigFishTerrainTileEntity.frameName,
	DeepSeaBigFishTerrainTileEntity,
);
map.set(
	DeepSeaMediumFishTerrainTileEntity.frameName,
	DeepSeaMediumFishTerrainTileEntity,
);
map.set(DeepSeaTerrainTileEntity.frameName, DeepSeaTerrainTileEntity);
map.set(DenseForestTerrainTileEntity.frameName, DenseForestTerrainTileEntity);
map.set(ForestTerrainTileEntity.frameName, ForestTerrainTileEntity);
map.set(GemsVeinTerrainTileEntity.frameName, GemsVeinTerrainTileEntity);
map.set(GoldVeinTerrainTileEntity.frameName, GoldVeinTerrainTileEntity);
map.set(GrasslandTerrainTileEntity.frameName, GrasslandTerrainTileEntity);
map.set(Grassland1TerrainTileEntity.frameName, Grassland1TerrainTileEntity);
map.set(Grassland2TerrainTileEntity.frameName, Grassland2TerrainTileEntity);
map.set(Grassland3TerrainTileEntity.frameName, Grassland3TerrainTileEntity);
map.set(Grassland4TerrainTileEntity.frameName, Grassland4TerrainTileEntity);
map.set(RuinedForestTerrainTileEntity.frameName, RuinedForestTerrainTileEntity);
map.set(HillsTerrainTileEntity.frameName, HillsTerrainTileEntity);
map.set(MountainsTerrainTileEntity.frameName, MountainsTerrainTileEntity);
map.set(OldForestTerrainTileEntity.frameName, OldForestTerrainTileEntity);
map.set(River10TerrainTileEntity.frameName, River10TerrainTileEntity);
map.set(River11TerrainTileEntity.frameName, River11TerrainTileEntity);
map.set(River12TerrainTileEntity.frameName, River12TerrainTileEntity);
map.set(River13TerrainTileEntity.frameName, River13TerrainTileEntity);
map.set(River14TerrainTileEntity.frameName, River14TerrainTileEntity);
map.set(River15TerrainTileEntity.frameName, River15TerrainTileEntity);
map.set(River3TerrainTileEntity.frameName, River3TerrainTileEntity);
map.set(River5TerrainTileEntity.frameName, River5TerrainTileEntity);
map.set(River6TerrainTileEntity.frameName, River6TerrainTileEntity);
map.set(River7TerrainTileEntity.frameName, River7TerrainTileEntity);
map.set(River9TerrainTileEntity.frameName, River9TerrainTileEntity);
map.set(RiverDelta1TerrainTileEntity.frameName, RiverDelta1TerrainTileEntity);
map.set(RiverDelta2TerrainTileEntity.frameName, RiverDelta2TerrainTileEntity);
map.set(RiverDelta4TerrainTileEntity.frameName, RiverDelta4TerrainTileEntity);
map.set(RiverDelta8TerrainTileEntity.frameName, RiverDelta8TerrainTileEntity);
map.set(RiverSpring1TerrainTileEntity.frameName, RiverSpring1TerrainTileEntity);
map.set(RiverSpring2TerrainTileEntity.frameName, RiverSpring2TerrainTileEntity);
map.set(RiverSpring4TerrainTileEntity.frameName, RiverSpring4TerrainTileEntity);
map.set(RiverSpring8TerrainTileEntity.frameName, RiverSpring8TerrainTileEntity);
map.set(
	SettlementEmptyTerrainTileEntity.frameName,
	SettlementEmptyTerrainTileEntity,
);
map.set(
	SettlementEmpty1TerrainTileEntity.frameName,
	SettlementEmpty1TerrainTileEntity,
);
map.set(
	SettlementEmpty2TerrainTileEntity.frameName,
	SettlementEmpty2TerrainTileEntity,
);
map.set(
	SettlementEmpty3TerrainTileEntity.frameName,
	SettlementEmpty3TerrainTileEntity,
);
map.set(
	SettlementEmpty4TerrainTileEntity.frameName,
	SettlementEmpty4TerrainTileEntity,
);
map.set(
	SettlementEmpty5TerrainTileEntity.frameName,
	SettlementEmpty5TerrainTileEntity,
);
map.set(
	SettlementEmpty6TerrainTileEntity.frameName,
	SettlementEmpty6TerrainTileEntity,
);
map.set(
	SettlementEmpty7TerrainTileEntity.frameName,
	SettlementEmpty7TerrainTileEntity,
);
map.set(
	SettlementEmpty8TerrainTileEntity.frameName,
	SettlementEmpty8TerrainTileEntity,
);
map.set(
	SettlementEmpty9TerrainTileEntity.frameName,
	SettlementEmpty9TerrainTileEntity,
);
map.set(
	SettlementEmpty10TerrainTileEntity.frameName,
	SettlementEmpty10TerrainTileEntity,
);
map.set(
	SettlementEmpty11TerrainTileEntity.frameName,
	SettlementEmpty11TerrainTileEntity,
);
map.set(
	SettlementEmpty12TerrainTileEntity.frameName,
	SettlementEmpty12TerrainTileEntity,
);
map.set(
	SettlementEmpty13TerrainTileEntity.frameName,
	SettlementEmpty13TerrainTileEntity,
);
map.set(
	SettlementEmpty14TerrainTileEntity.frameName,
	SettlementEmpty14TerrainTileEntity,
);
map.set(
	SettlementEmpty15TerrainTileEntity.frameName,
	SettlementEmpty15TerrainTileEntity,
);
map.set(
	SettlementEmpty16TerrainTileEntity.frameName,
	SettlementEmpty16TerrainTileEntity,
);
map.set(
	SettlementEmpty17TerrainTileEntity.frameName,
	SettlementEmpty17TerrainTileEntity,
);
map.set(
	SettlementEmpty18TerrainTileEntity.frameName,
	SettlementEmpty18TerrainTileEntity,
);
map.set(
	SettlementEmpty19TerrainTileEntity.frameName,
	SettlementEmpty19TerrainTileEntity,
);
map.set(
	ShallowSeaMediumFishTerrainTileEntity.frameName,
	ShallowSeaMediumFishTerrainTileEntity,
);
map.set(
	ShallowSeaRocksTerrainTileEntity.frameName,
	ShallowSeaRocksTerrainTileEntity,
);
map.set(
	ShallowSeaSmallFishTerrainTileEntity.frameName,
	ShallowSeaSmallFishTerrainTileEntity,
);
map.set(ShallowSeaTerrainTileEntity.frameName, ShallowSeaTerrainTileEntity);
map.set(SwampTerrainTileEntity.frameName, SwampTerrainTileEntity);
map.set(
	IronMountainsTerrainTileEntity.frameName,
	IronMountainsTerrainTileEntity,
);
map.set(
	ShallowSeaCoralReefTerrainTileEntity.frameName,
	ShallowSeaCoralReefTerrainTileEntity,
);
map.set(
	DeepSeaCoralReefTerrainTileEntity.frameName,
	DeepSeaCoralReefTerrainTileEntity,
);
map.set(CoalDepositTerrainTileEntity.frameName, CoalDepositTerrainTileEntity);
map.set(SaltDepositTerrainTileEntity.frameName, SaltDepositTerrainTileEntity);

// TODO: rename + rename file
export const getTerrainTileEntity = (
	type: FrameName,
): typeof TileEntity | null => (map.has(type) ? map.get(type)! : null);

// TODO: rename + rename file
export const createTerrainTileEntity = (
	type: FrameName,
	coordinates: TileCoordinates,
	tilerepo: TileRepository,
): TileEntity | null => {
	const entity = getTerrainTileEntity(type);
	return entity ? new entity(coordinates, tilerepo) : null;
};
